import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { KnowledgeSource } from '@kizen/api/knowledge';
import Select from '__components/Inputs/Select';

export const KnowledgeTypeSelect: FC<{
  value: KnowledgeSource['knowledge_type'];
  onChange: (value: KnowledgeSource['knowledge_type']) => void;
  hideLabel?: boolean;
  margin?: boolean;
}> = ({ value, onChange, hideLabel, margin }) => {
  const { t } = useTranslation();

  const handleChangeKnowledgeType = (opt: {
    value: KnowledgeSource['knowledge_type'];
  }) => {
    onChange(opt.value);
  };

  const options = useMemo<
    {
      value: KnowledgeSource['knowledge_type'];
      label: string;
    }[]
  >(() => {
    return [
      {
        value: 'business',
        label: hideLabel ? t('Business knowledge') : t('Business'),
      },
      {
        value: 'general',
        label: hideLabel ? t('General knowledge') : t('General'),
      },
    ];
  }, [hideLabel, t]);

  return (
    <Select
      label={!hideLabel && t('Knowledge Type')}
      value={value}
      onChange={handleChangeKnowledgeType}
      options={options}
      margin={margin}
      className="knowledge-type-select"
    />
  );
};
